export default {
    extract_list: null
};
